// extracted by mini-css-extract-plugin
export default {"container":"w1ilwg","header":"uFXaxY","background":"jdZzwx"};